import {combineReducers} from 'redux';

// @ts-expect-error
import {TinyIntroduction, TinyIntroState} from './auth';
// @ts-expect-error
import {connectedFormsReducer, ConnectedFormsState} from './connected-forms';
// @ts-expect-error
import {creatorReducer, CreatorState} from './creator';
import {
    emailComposerReducer,
    // @ts-expect-error
    EmailComposerState,
    emailReplyReducer,
    // @ts-expect-error
    EmailReplyState,
} from './email';
import {
    visitorsSidebarReducer,
    // @ts-expect-error
    VisitorsSidebarState,
} from './email-marketing/visitors/visitors-sidebar';
// @ts-expect-error
import {glossaryReducer, GlossaryState} from './glossary/redux';
import {
    chatReducer,
    // @ts-expect-error
    ChatState,
    smsReducer,
    // @ts-expect-error
    SMSState,
    facebookReducer,
    // @ts-expect-error
    FacebookState,
    instagramReducer,
    // @ts-expect-error
    InstagramState,
    chatbotReducer,
    // @ts-expect-error
    ChatbotState,
    whatsappReducer,
    // @ts-expect-error
    WhatsAppState,
} from './inbox/dashboard/report';
// @ts-expect-error
import {limitsReducer, LimitsState} from './limits';
// @ts-expect-error
import {messagesReducer, MessagesState} from './messages';
// @ts-expect-error
import {onboardingReducer, OnboardingState} from './onboarding/onboarding-checklist/redux';
// @ts-expect-error
import {openableModalsReducer, OpenableModalsState} from './openable-modals';
// @ts-expect-error
import {peopleIqReducer, PeopleIqState} from './people-iq/redux';
import {
    engagementLeadsReducer,
    engagementSalesReducer,
    widgetOpensReducer,
    completedActionsReducer,
    // @ts-expect-error
    EngagementLeadsState,
    // @ts-expect-error
    EngagementSalesState,
    // @ts-expect-error
    WidgetOpensState,
    // @ts-expect-error
    CompletedActionsState,
} from './reports/engagement';
// @ts-expect-error
import {SalesAutomationUi, SalesAutomationUiState} from './sales-automation';
// @ts-expect-error
import {sidebarReducer, SidebarState} from './sidebar/sidebar-reducer';
// @ts-expect-error
import {tasksReducer, CreatorTasksState} from './tasks';

export type UiState = {
    creator: CreatorState;
    tasks: CreatorTasksState;
    salesAutomation: SalesAutomationUiState;
    tinyIntroduction: TinyIntroState;
    sidebar: SidebarState;
    emailComposer: EmailComposerState;
    emailReply: EmailReplyState;
    messages: MessagesState;
    connectedForms: ConnectedFormsState;
    openableModals: OpenableModalsState;
    visitorsSidebar: VisitorsSidebarState;
    limits: LimitsState;
    glossary: GlossaryState;
    onboarding: OnboardingState;
    peopleIq: PeopleIqState;
    chat: ChatState;
    sms: SMSState;
    facebook: FacebookState;
    instagram: InstagramState;
    chatbot: ChatbotState;
    whatsapp: WhatsAppState;
    engagementLeads: EngagementLeadsState;
    engagementSales: EngagementSalesState;
    widgetOpens: WidgetOpensState;
    completedActions: CompletedActionsState;
};

export const uiReducer = combineReducers({
    creator: creatorReducer,
    tasks: tasksReducer,
    salesAutomation: SalesAutomationUi.uiReducer,
    tinyIntroduction: TinyIntroduction.tinyIntroReducer,
    sidebar: sidebarReducer,
    emailComposer: emailComposerReducer,
    emailReply: emailReplyReducer,
    messages: messagesReducer,
    connectedForms: connectedFormsReducer,
    openableModals: openableModalsReducer,
    visitorsSidebar: visitorsSidebarReducer,
    limits: limitsReducer,
    glossary: glossaryReducer,
    onboarding: onboardingReducer,
    peopleIq: peopleIqReducer,
    chat: chatReducer,
    sms: smsReducer,
    facebook: facebookReducer,
    instagram: instagramReducer,
    chatbot: chatbotReducer,
    whatsapp: whatsappReducer,
    engagementLeads: engagementLeadsReducer,
    engagementSales: engagementSalesReducer,
    widgetOpens: widgetOpensReducer,
    completedActions: completedActionsReducer,
});
